import React from "react";
import PropTypes from "prop-types";

import { MicrodataContext } from "config/contexts";

import styles from "./Headline.css";

export default function Headline({ headline, seoHeadline }) {
  return (
    <MicrodataContext.Consumer>
      {microdata => (
        <React.Fragment>
          {microdata && (
            <meta itemProp="headline" content={seoHeadline || headline} />
          )}
          <h3 className={styles.headline}>{headline}</h3>
        </React.Fragment>
      )}
    </MicrodataContext.Consumer>
  );
}

Headline.propTypes = {
  headline: PropTypes.string.isRequired,
  seoHeadline: PropTypes.string,
};
